import { Chip } from '@mui/material';

import { dpvColors } from '@/theme/palette';

interface EstadoBadgeProps {
  informeFinalEmitido: boolean;
}

export function EstadoBadge({ informeFinalEmitido }: EstadoBadgeProps): JSX.Element {
  if (informeFinalEmitido) {
    return (
      <Chip
        label="Cerrado"
        size="small"
        sx={{ bgcolor: 'success.main', color: 'success.contrastText', fontWeight: 500 }}
      />
    );
  }
  return (
    <Chip
      label="En curso"
      size="small"
      sx={{
        bgcolor: dpvColors.naranja.light,
        color: dpvColors.naranja.dark,
        fontWeight: 500,
      }}
    />
  );
}
